import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function Education() {
  return (
    <div
      className="bg-blue w-full h-full lg:px-16 px-7 overflow-x-hidden font-poor-story text-white lg:text-2xl md:text-lg text-base leading-loose tracking-widest"
      data-aos="fade-right"
      data-aos-easing="ease-in-sine"
      data-aos-duration="400">
      <Navbar
        pageTitle="Education"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="500"
      />

      {/* COLLEGE EDU */}
      <div
        className="mt-24"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="600">
        <h1 className="text-3xl my-9">College Education</h1>
        <div className="flex items-start flex-col gap-1">
          <p className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <em>Bachelor of Commerce - Al-Azhar University</em>
          </p>
          <p className="pl-7">- Nasr City Branch</p>
          <p className="pl-7">- Business Administration Department</p>
          <p className="pl-7">- 2018 : 2022</p>
          <p className="pl-7">
            - GPA: Very Good{" "}
            <small>
              (3<sup>rd</sup> of Class)
            </small>{" "}
          </p>
        </div>
      </div>

      {/*  TRAINING */}
      <div className="mt-24">
        <h1 className="text-3xl my-9">Training</h1>
        <div className="flex items-start flex-col gap-1">
          <p className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <em>Web Development - ITI & Yat Learning Centers</em>
          </p>
          <p className="pl-7">- Dec 2020 : Feb 2021</p>
          <p className="pl-7">
            - Study & Practice all the fundamentals for <br /> Full Stack Web
            Development and some other helping tools.
          </p>
        </div>
      </div>

      {/*  Courses */}
      <div
        className="mt-24 flex flex-col gap-10"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="400">
        <h1 className="text-3xl">Courses</h1>
        <div className="flex items-start flex-col gap-1">
          <p className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <em>Vue, The Complete Guide - Udemy</em>
          </p>
          <p className="pl-7">- By Maximilian Schwarzmuller </p>
          <p className="pl-7">
            - Certificate{" "}
            <a
              href="https://drive.google.com/file/d/1C-qVgooQItpOMdysNWZ59HiKEhTEYp0L/view?usp=sharing"
              target="_blank"
              rel="noreferrer">
              <img
                src={require("../assets/icons/arrow up.png")}
                alt="arrow"
                className="inline w-6"
              />
            </a>
          </p>
        </div>
        <div className="flex items-start flex-col gap-1">
          <p className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <em>Professional Web Development - MCIT & Udacity</em>
          </p>
          <p className="pl-7">
            - Certificate{" "}
            <a
              href="https://drive.google.com/file/d/1C-PNzfNSX_bE_L4kkMXWt_ay_yX7mQst/view?usp=sharing"
              target="_blank"
              rel="noreferrer">
              <img
                src={require("../assets/icons/arrow up.png")}
                alt="arrow"
                className="inline w-6"
              />
            </a>
          </p>
        </div>
        <div className="flex items-start flex-col gap-1">
          <p className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <em>JavaScript Development - ITI Platform</em>
          </p>
          <p className="pl-7">- 3 Training Courses </p>
          <p className="pl-7">
            - Certificate{" "}
            <a
              href="https://drive.google.com/file/d/1BlVLHPHhtc3MIMTEvg2JHz5YB33ZaZDE/view?usp=sharing"
              target="_blank"
              rel="noreferrer">
              <img
                src={require("../assets/icons/arrow up.png")}
                alt="arrow"
                className="inline w-6"
              />
            </a>
          </p>
        </div>
        <div className="flex items-start flex-col gap-1">
          <p className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <em>Technical Support Fundamentals - Google & Coursera</em>
          </p>
          <p className="pl-7">
            - Certificate{" "}
            <a
              href="https://drive.google.com/file/d/1C2sHIfxXRgVFR9QEe1mosNqYskU59pzF/view?usp=sharing"
              target="_blank"
              rel="noreferrer">
              <img
                src={require("../assets/icons/arrow up.png")}
                alt="arrow"
                className="inline w-6"
              />
            </a>
          </p>
        </div>
        <div className="flex items-start flex-col gap-1">
          <p className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <em>Operating Systems - Google & Coursera</em>
          </p>
          <p className="pl-7">
            - Certificate{" "}
            <a
              href="https://drive.google.com/file/d/1C1NfFWXw7WrgNvH9hpjRYM7yPLWcY_CN/view?usp=sharing"
              target="_blank"
              rel="noreferrer">
              <img
                src={require("../assets/icons/arrow up.png")}
                alt="arrow"
                className="inline w-6"
              />
            </a>
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Education;
